import React from 'react'

export default ({ color }) => (
  <svg
    with="30"
    height="30"
    viewBox="0 0 268 268"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill={color || '#fff'}>
      <path d="M268 268h-59L91 148.666l27.613-27.925L228.865 232.24V0H268z" />
      <path d="M203.693 0L39.183 165.742V268H0V0h39.283v109.691L148.159 0z" />
    </g>
  </svg>
)



// WEBPACK FOOTER //
// ./src/ui/components/generic/Logo.js